export const DIRECTIONS = ["north", "east", "south", "west"] as const;
export type Direction = (typeof DIRECTIONS)[number];

export const DIRECTION_COLORS = ["cyan", "orange", "purple", "lime"] as const;
export type DirectionColor = (typeof DIRECTION_COLORS)[number];

export type StageId = "tutorial" | "material" | "scenario" | "combined";
export type TaskMode = StageId;

export interface TargetDefinition {
  readonly groundId: string;
  readonly environmentId: string;
}

export interface ScheduledTrial {
  readonly stageId: StageId;
  readonly trialIndex: number;
  readonly target: TargetDefinition;
  readonly targetDirection: Direction;
}

export interface CandidateDefinition extends TargetDefinition {
  readonly direction: Direction;
  readonly isTarget: boolean;
}

export type DirectionColorMap = Readonly<Record<Direction, DirectionColor>>;

export interface StageConfig {
  readonly id: StageId;
  readonly mode: TaskMode;
  readonly requiredCorrect: number;
}

export interface TrainingConfig {
  readonly mode: "formal" | "dev_fast";
  readonly assistanceAfterErrors: number;
  readonly groundIds: readonly string[];
  readonly environmentIds: readonly string[];
  readonly tutorialTargets: readonly TargetDefinition[];
  readonly stages: readonly StageConfig[];
}
